/* Landings do GemPages congeladas (work/montar_landing.py): o que o runtime do GemPages fazia,
   sem carregar nada dele. Contagem regressiva, galeria do produto, acordeão e vídeos. */
(function () {
  var dois = function (n) { return (n < 10 ? '0' : '') + n; };

  // contagem "evergreen": cada visitante tem o próprio ciclo, que recomeça ao zerar
  document.querySelectorAll('gp-countdown-timer[data-tpb-cd]').forEach(function (c, i) {
    var ciclo = +c.getAttribute('data-tpb-cd') || 43200, chave = 'tpb-cd-' + location.pathname + '-' + i, inicio;
    try { inicio = +localStorage.getItem(chave); if (!inicio) { inicio = Date.now(); localStorage.setItem(chave, inicio); } }
    catch (e) { inicio = Date.now(); }
    var campo = function (id) { var e = c.querySelector('#' + id + ' .gp-countdown-number'); return e; };
    var d = campo('day'), h = campo('hour'), m = campo('minute'), s = campo('second');
    var tique = function () {
      var resto = ciclo - Math.floor((Date.now() - inicio) / 1000) % ciclo;
      var dd = Math.floor(resto / 86400), hh = Math.floor(resto % 86400 / 3600), mm = Math.floor(resto % 3600 / 60), ss = resto % 60;
      if (!d) hh += dd * 24;
      if (d) d.textContent = dois(dd);
      if (h) h.textContent = dois(hh);
      if (m) m.textContent = dois(mm);
      if (s) s.textContent = dois(ss);
    };
    tique(); setInterval(tique, 1000);
  });

  // galeria do produto: uma foto por vez, setas e arrasto (rolagem com encaixe no CSS)
  document.querySelectorAll('gp-carousel').forEach(function (car) {
    var trilho = car.querySelector('.gp-carousel-slider, [class*="gp-carousel-slider"], .gem-slider') || car.querySelector('[id^="gp-carousel"]');
    if (!trilho) return;
    var anda = function (dir) { trilho.scrollBy({ left: dir * trilho.clientWidth, behavior: 'smooth' }); };
    car.querySelectorAll('.gp-carousel-arrow-gp-carousel, [class*="carousel-arrow"], button[aria-label*="rev"], button[aria-label*="ext"]').forEach(function (b) {
      var volta = /prev|left/i.test((b.className || '') + ' ' + (b.getAttribute('aria-label') || ''));
      b.addEventListener('click', function (ev) { ev.preventDefault(); anda(volta ? -1 : 1); });
    });
    car.querySelectorAll('[data-gp-carousel-dot], .gp-carousel-dot, [class*="carousel-dot"]').forEach(function (p, k) {
      p.addEventListener('click', function () { trilho.scrollTo({ left: k * trilho.clientWidth, behavior: 'smooth' }); });
    });
  });

  // acordeão (perguntas): um aberto por vez
  document.querySelectorAll('gp-accordion').forEach(function (acc) {
    var itens = [].slice.call(acc.querySelectorAll('.gp-accordion-item'));
    var corpo = function (i) { return i.querySelector('.gp-accordion-item_body'); };
    var marcar = function (i, on) { var b = corpo(i); if (!b) return; b.dataset.show = on; b.style.gridTemplateRows = on ? '1fr' : '0fr'; };
    itens.forEach(function (i) {
      var cab = i.querySelector('.gp-accordion-item_header');
      if (!cab) return;
      cab.addEventListener('click', function () {
        var on = corpo(i).dataset.show !== 'true';
        itens.forEach(function (o) { if (o !== i) marcar(o, false); });
        marcar(i, on);
      });
    });
  });

  // interações do GemPages: mostrar/esconder ao carregar a página e no clique ("See Full List")
  var dado = document.getElementById('tpb-gp-interaction'), regras = [];
  try { regras = dado ? JSON.parse(dado.textContent) : []; } catch (e) { regras = []; }
  var mostra = function (el) { return el.tagName === 'GP-ROW' ? 'grid' : 'block'; };
  var aplica = function (alvos) {
    (alvos || []).forEach(function (t) {
      var el = document.getElementById(t.uid); if (!el) return;
      (t.events || []).forEach(function (ev) {
        if (ev.controlId !== 'gp:show-or-hide') return;
        var cond = (ev.condition || {}).data;
        if (cond === 'hidden') el.style.setProperty('display', 'none', 'important');
        else if (cond === 'appearByTrigger') el.style.setProperty('display', mostra(el), 'important');
      });
    });
  };
  regras.forEach(function (r) {
    var s = r.self || {};
    if (s.event === 'finish-loading') aplica(r.targets);
    else if (s.event === 'click') {
      var gatilho = document.getElementById(s.uid); if (!gatilho) return;
      gatilho.style.cursor = 'pointer';
      gatilho.addEventListener('click', function (ev) { ev.preventDefault(); aplica(r.targets); });
    }
  });

  // vídeos de fundo: tocam mudos quando entram na tela
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; if (e.isIntersecting && v.paused && v.autoplay) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
    }, { rootMargin: '200px' });
    document.querySelectorAll('.tpb-lp video').forEach(function (v) { v.muted = true; io.observe(v); });
  }
})();

// acordeão das seções cw_* da referência: a pergunta aberta mede a resposta antes da fonte
// carregar e fica cortada; mede de novo quando página e fontes terminam
(function () {
  function remedir() {
    document.querySelectorAll('.cw-faq-item.active .cw-faq-answer').forEach(function (a) {
      a.style.maxHeight = a.scrollHeight + 'px';
    });
  }
  window.addEventListener('load', remedir);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(remedir);
})();

// barra de compra fixa no rodapé do celular (gp-sticky): na referência o script do GemPages
// mostra a barra depois de um ponto da rolagem, medido página a página (work/lp/barra-fixa-limites.json),
// e esconde de novo perto do topo; no computador ela não aparece
(function () {
  var LIM = { 'adv2-1': 1250, 'adv2copy': 1250, 'wecompared': 1250, 'l3': 1000, 'l4': 1000, 'l5': 1100, 'l6': 1050, 'ranking': 1200, 'shival-gp-ranking': 1150 };
  var h = location.pathname.replace(/\/$/, '').split('/').pop(), lim = LIM[h];
  if (!lim) return;
  var els = [].slice.call(document.querySelectorAll('gp-sticky')).filter(function (e) {
    var s = e.getAttribute('style') || ''; return s.indexOf('--bottom:0') > -1 && s.indexOf('--pos:fixed') > -1;
  });
  if (!els.length) return;
  function marca() {
    var on = window.innerWidth < 768 && window.scrollY >= lim;
    els.forEach(function (e) { e.classList.toggle('isShow', on); });
  }
  window.addEventListener('scroll', marca, { passive: true });
  window.addEventListener('resize', marca);
  marca();
})();
